(function (window) {
  function Node(point, left, right) {
    this.point = point;
    this.left = left;
    this.right = right;
  }

  function BatchGeoKdTree(cities, startCity, startCityIndex) {
    if (cities) {
      this.points = cities.map((city) => [
        city && city.latitude,
        city && city.longitude,
      ]);
      this.cities = cities;
    }
    this.startCity = startCity;
    this.startCityIndex = startCityIndex;
  }

  BatchGeoKdTree.prototype.run = function () {
    let startLocation = this.startCityIndex;
    const nearestPointLatLng = this.findNearestCity(
      this.points,
      this.startCity,
    );
    if (nearestPointLatLng == -1) return -1;

    const nearestCityObject = this.findNearestCityName(
      this.cities,
      nearestPointLatLng,
      startLocation,
    );

    const queryLocationName = this.findNearestCityName(
      this.cities,
      this.startCity,
      startLocation,
    );

    let dist = this.haversineDistance(this.startCity, nearestPointLatLng);
    console.log(nearestCityObject);

    let city = {
      nearestCity: nearestCityObject.nearestCity,
      location: nearestPointLatLng,
      startCity: queryLocationName.nearestCity,
      distance: dist,
      startCityIndex: this.startCityIndex,
      endCityIndex: nearestCityObject.actualCityCount,
    };
    return city;
  };

  BatchGeoKdTree.prototype.buildKdTree = function (points, depth = 0) {
    if (points.length === 0) {
      return null;
    }

    const axis = depth % 2;

    points.sort((a, b) => a[axis] - b[axis]);

    const medianIndex = Math.floor(points.length / 2);
    const medianPoint = points[medianIndex];

    const node = {
      point: medianPoint,
      left: this.buildKdTree(points.slice(0, medianIndex), depth + 1),
      right: this.buildKdTree(points.slice(medianIndex + 1), depth + 1),
    };

    return node;
  };

  BatchGeoKdTree.prototype.haversineDistance = function (point1, point2) {
    let distanceScale = window.batchGeoGoogleMapsManager.getDistanceScale();

    var earthRadius = {
      km: 6371,
      m: 6371 * 1000, // radius in meters times meters in a kilometer
      mi: 3959,
      ft: 3959 * 5280, // radius in miles times feet in a mile
    };

    const [lat1, lon1] = point1;
    const [lat2, lon2] = point2;

    const deltaLat = this.toRadians(lat2 - lat1);
    const deltaLon = this.toRadians(lon2 - lon1);

    const a =
      Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(this.toRadians(lat1)) *
        Math.cos(this.toRadians(lat2)) *
        Math.sin(deltaLon / 2) *
        Math.sin(deltaLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius[distanceScale] * c;

    return distance;
  };

  BatchGeoKdTree.prototype.toRadians = function (degrees) {
    return (degrees * Math.PI) / 180;
  };

  BatchGeoKdTree.prototype.findNearestCity = function (cities, searchPoint) {
    // Build k-d tree

    // remove self from the list?
    cities = cities.filter(
      (city) => city[0] !== searchPoint[0] && city[1] !== searchPoint[1],
    );
    if (cities.length == 0) return -1;
    const root = this.buildKdTree(cities, 0);

    // Search for nearest city
    const nearest = this.search(root, searchPoint, 0, root.point);

    return nearest;
  };

  BatchGeoKdTree.prototype.findNearestCityName = function (
    cities,
    coordinates,
    _startLocationIndex,
  ) {
    const searchPoint = coordinates.map((coord) => (coord * Math.PI) / 180);
    // Calculate distance to each city and find nearest
    let minDist = Infinity;
    let nearestCity = null;
    let cityCount = 0;
    let actualCityCount = 0;
    cities.forEach((city) => {
      if (city != null) {
        const { name, latitude, longitude } = city;
        const cityCoords = [latitude, longitude].map(
          (coord) => (coord * Math.PI) / 180,
        );

        const dist = this.haversineDistance(searchPoint, cityCoords);

        if (dist < minDist) {
          minDist = dist;
          nearestCity = name;
          actualCityCount = cityCount;
        }
      }

      cityCount++;
    });

    return { nearestCity, minDist, actualCityCount };
  };

  BatchGeoKdTree.prototype.search = function (node, point, depth, nearest) {
    if (!node) {
      return nearest;
    }

    const distance = this.haversineDistance(node.point, point);

    if (distance < this.haversineDistance(nearest, point)) {
      nearest = node.point;
    }

    const axis = depth % 2;
    const left = node.left;
    const right = node.right;

    if (left && point[axis] < node.point[axis]) {
      nearest = this.search(left, point, depth + 1, nearest);
      if (
        right &&
        this.haversineDistance(point, nearest) >=
          this.haversineDistance(point, node.point)
      ) {
        nearest = this.search(right, point, depth + 1, nearest);
      }
    } else if (right && point[axis] >= node.point[axis]) {
      nearest = this.search(right, point, depth + 1, nearest);
      if (
        left &&
        this.haversineDistance(point, nearest) >=
          this.haversineDistance(point, node.point)
      ) {
        nearest = this.search(left, point, depth + 1, nearest);
      }
    }

    return nearest;
  };

  BatchGeoKdTree.prototype.Node = Node;

  window.BatchGeoKdTree = BatchGeoKdTree;
})(window);
